import { render } from "./sessionpopup.vue?vue&type=template&id=1485fdfa&scoped=true&ts=true"
import script from "./sessionpopup.vue?vue&type=script&lang=ts"
export * from "./sessionpopup.vue?vue&type=script&lang=ts"

import "./sessionpopup.vue?vue&type=style&index=0&id=1485fdfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1485fdfa"]])

export default __exports__